import React, { Component } from 'react'
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { flowRight as compose } from 'lodash';
import getFailedPayoutList from './getFailedPayoutList.graphql';
import FailedPayoutList from '../../../components/SiteAdmin/FailedPayout/FailedPayoutList';
import Loader from '../../../components/Common/Loader/Loader';
import messages from '../../../locale/messages';
import { withQuery } from '../../../hoc/withGraphql';
export class FailedPayout extends Component {

    static defaultProps = {
        booking: {
            loading: true
        }
    }

    render() {
        const { getFailedPayoutData, getFailedPayoutData: { loading } } = this.props;
        const { formatMessage } = this.props.intl;
        return (
            <Loader type={"page"} show={loading}>
                <h1 className='siteAdminPrimaryHeading'>{formatMessage(messages.manageFailedPayout)}</h1>
                {!loading && <FailedPayoutList getFailedPayoutData={getFailedPayoutData} />}
            </Loader>
        );
    }
}

export default compose(
    injectIntl,
    withQuery(getFailedPayoutList, {
        name: 'getFailedPayoutData',
        options: {
            variables: {
                currentPage: 1,
                searchList: ''
            },
            fetchPolicy: 'network-only',
            ssr: false
        }
    })
)(FailedPayout);
